
import { LockOpenIcon } from '@vue-hero-icons/outline';

export default {
  components: {
    LockOpenIcon,
  },

  props: {
    text: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: 'login',
    },
  },

  computed: {
    customer() {
      return this.$get(this.$$users, 'user', '');
    },
  },
};
